import { setForgerockConfig } from "@/utils/Auth/forgeRockService.service";
import { FRAuth } from "@forgerock/javascript-sdk";
import {
  JOURNEY_LOGIN_NORMAL,
  LOGIN_SUCCESS,
  ERROR,
} from "@/utils/Auth/authConstants";

export const userLogin = async (username, password) => {
  try {
    setForgerockConfig(JOURNEY_LOGIN_NORMAL);

    let loginStepZeroResponse: any = await FRAuth.start();
    let loginStepOneRequest: any = { ...loginStepZeroResponse };

    if (loginStepOneRequest?.type === LOGIN_SUCCESS) {
      return {
        status: LOGIN_SUCCESS,
        type: loginStepOneRequest?.type,
        response: JSON.stringify(loginStepOneRequest),
      };
    }

    loginStepOneRequest.payload.callbacks[0].input[0].value = username;
    loginStepOneRequest.payload.callbacks[1].input[0].value = password;

    const loginStepOneResponse: any = await FRAuth.next(loginStepOneRequest);
    let value =
      loginStepOneResponse.payload?.callbacks?.[0]?.output?.[0]?.value;

    return {
      status: value,
      type: loginStepOneResponse?.type,
      response: JSON.stringify(loginStepOneResponse),
    };
  } catch (e) {
    console.log('error fg: ',  e);
    return {
      status: null,
      type: null,
      response: e,
    };
  }
};

export const verifyOTPLogin = async (otp, stepOneResponse) => {
  try {
    let journeyStepTwoRequest = JSON.parse(stepOneResponse);
    journeyStepTwoRequest.payload.callbacks[0].input[0].value = otp;

    const journeyStepTwoResponse: any = await FRAuth.next(
      journeyStepTwoRequest
    );

    const value =
      journeyStepTwoResponse.payload?.callbacks?.[0]?.output?.[0]?.value;
    return {
      status: value,
      type: journeyStepTwoResponse?.type,
      response: JSON.stringify(journeyStepTwoResponse),
    };
  } catch (e) {
    console.error("verifyOTPLogin error --->", e);
    return {
      status: ERROR,
      type: null,
      response: e,
    };
  }
};

export const reVerifyOTPResponse = async (response) => {
  try {
    let journeyStepThreeRequest = response;
    const journeyStepThreeResponse: any = await FRAuth.next(
      journeyStepThreeRequest
    );
    const value =
      journeyStepThreeResponse.payload?.callbacks?.[0]?.output?.[0]?.value;
    return {
      status: value,
      type: journeyStepThreeResponse?.type,
      response: JSON.stringify(journeyStepThreeResponse),
    };
  } catch (e) {
    return {
      status: ERROR,
      type: null,
      response: e,
    };
  }
};

export const reVerifyOTPLogin = async (otp) => {
  try {
    let journeyStepThreeRequest = otp;
    const journeyStepThreeResponse: any = await FRAuth.next(
      journeyStepThreeRequest
    );
    const value =
      journeyStepThreeResponse.payload?.callbacks?.[0]?.output?.[0]?.value;
    return {
      status: value,
      type: journeyStepThreeResponse?.type,
      response: JSON.stringify(journeyStepThreeResponse),
    };
  } catch (e) {
    return {
      status: ERROR,
      type: null,
      response: e,
    };
  }
};

// export const verifyOTPReLogin = async (otp, stepOneResponse) => {
//   try {
//     let journeyStepTwoRequest = JSON.parse(stepOneResponse);
//     journeyStepTwoRequest.payload.callbacks[0].input[0].value = otp;
//     const journeyStepTwoResponse: any = await FRAuth.next(
//       journeyStepTwoRequest
//     );
//     const value =
//       journeyStepTwoResponse.payload?.callbacks?.[0]?.output?.[0]?.value;
//     return {
//       status: value,
//       type: journeyStepTwoResponse?.type,
//       response: JSON.stringify(journeyStepTwoResponse),
//     };
//   } catch (e) {
//     console.log("verifyOTPLogin error --->", e);
//     return {
//       status: ERROR,
//       type: null,
//       response: e,
//     };
//   }
// };
